import { Component, ViewEncapsulation, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables, GlobalRef } from '../../../common/global-variables';
import { AUTH_CONSTANTS } from '../../auth/auth-constants';
import { ResizeEvent } from 'angular-resizable-element';
import { GuidedTour, GuidedTourBuilder } from '../../../app/services/guided-tour-builder/guided-tour-builder.service';
import { ServicesGuidedTourData } from './services-main.guidedtour.data';
const _ = require('lodash');

@Component({
    selector: 'services-main',
    providers: [],
    encapsulation: ViewEncapsulation.None,
    styles: [],
    // host: { '[class.content-container]': 'true' },
    template: require('./services-main.html'),
})
export default class ServicesMain implements OnInit, AfterViewInit, OnDestroy {
    private isVCEnvironment: boolean = true;
    private sideNavStyle: Object = {};
    private guidedTourData: ServicesGuidedTourData;
    // isVCDGVRDepricated is used to differentiate between old and new VCD GVR where entity creation is not supported anymore.
    private isVCDGVRDepricated: boolean = false;
    private isVIOOrgAdmin: boolean = false;
    private isSystemAdmin: boolean = false;

    constructor(public authService: AuthService,
                private translate: TranslateService,
                private globalRef: GlobalRef,
                private guidedTourBuilder: GuidedTourBuilder) {

        this.guidedTourData = new ServicesGuidedTourData(
            this.translate, this.authService, this,
            this.globalRef, this.guidedTourBuilder);
    }

    public ngOnInit() {
        // isVCDGVRDepricated is used to hide Compute, Networking and DPS items.
        this.isVCDGVRDepricated = this.authService.isVCDGVRDepricated;
        let roles = (this.authService.loggedInUserInfo && this.authService.loggedInUserInfo.roles) ? this.authService.loggedInUserInfo.roles : [];
        if (_.includes(roles, AUTH_CONSTANTS.SysAdmin)) {
            this.isSystemAdmin = true;
        }

        if (this.authService.VREALM_TYPE === AUTH_CONSTANTS.VCD) {
            this.isVCEnvironment = false;
        } else if (this.authService.VREALM_TYPE === AUTH_CONSTANTS.VC) {
            this.isVCEnvironment = true;
        } else if (this.authService.VREALM_TYPE === AUTH_CONSTANTS.VIO) {
            if (_.includes(roles, AUTH_CONSTANTS.OrgAdmin)) {
                this.isVIOOrgAdmin = true;
            }
        }
        console.debug('Building "overview" Guided Tour for Services...');
    }

    public ngAfterViewInit() {

    }

    public onResizeEnd(event: ResizeEvent): void {
        this.sideNavStyle = {
            width: `${event.rectangle.width}px`
        };
    }

    public ngOnDestroy() {
        this.guidedTourData.parkToursAndCleanup();
    }

    // TODO update to use featureConfig API - This is only for DEMO of HCX Onprem SA 2/2019
    private isFeatureEnabled(feature: string, operation: string): boolean {

        if (feature === 'COMPUTE_VIEW') {
            if (operation === 'VISIBLE') {
                return false;
            }
        } else if (feature === 'NETWORKING_VIEW') {
            if (operation === 'VISIBLE') {
                return false;
            }
        } else if (feature === 'DATA_PROTECTION_VIEW') {
            if (operation === 'VISIBLE') {
                return false;
            }
        } else if (feature === 'NETWORKS_VIEW') {
            if (operation === 'VISIBLE') {
                return false;
            }
        } else if (feature === 'MIGRATION_VIEW') {
            if (operation === 'VISIBLE') {
                return true;
            }
        } else if (feature === 'DISASTER_RECOVERY_VIEW') {
            if (operation === 'VISIBLE') {
                return true;
            }
        } else if (feature === 'NETWORK_EXTENSION_VIEW') {
            if (operation === 'VISIBLE') {
                return true;
            }
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/services-main/services-main.component.ts